function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { Paper, Tabs, Tab, Box } from "@mui/material";
export default function TabPanels(param) {
    var tabs = param.tabs, _param_defaultTabId = param.defaultTabId, defaultTabId = _param_defaultTabId === void 0 ? tabs[0].id : _param_defaultTabId;
    var _React_useState = _sliced_to_array(React.useState(defaultTabId), 2), currentTab = _React_useState[0], setCurrentTab = _React_useState[1];
    return /*#__PURE__*/ _jsxs(Paper, {
        square: true,
        children: [
            /*#__PURE__*/ _jsx(Tabs, {
                value: currentTab,
                onChange: function(_, nextTabId) {
                    return setCurrentTab(nextTabId);
                },
                children: tabs.map(function(tab) {
                    return /*#__PURE__*/ _jsx(Tab, {
                        value: tab.id,
                        label: tab.title
                    }, tab.id);
                })
            }),
            tabs.map(function(tab) {
                return /*#__PURE__*/ _jsx(TabPanel, {
                    index: tab.id,
                    value: currentTab,
                    children: tab.panelChildren
                }, tab.id);
            })
        ]
    });
}
function TabPanel(param) {
    var children = param.children, index = param.index, value = param.value;
    return /*#__PURE__*/ _jsx("div", {
        hidden: value !== index,
        children: value === index && /*#__PURE__*/ _jsx(Box, {
            sx: {
                padding: "2em"
            },
            children: children
        })
    });
}
